.popover {
  position: fixed;

  position-area: bottom center;
  position-try: normal flip-block;

  width: 100%;

  border: unset;
  background-color: unset;
}
